/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_TimecodesInputs */

const en_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy timecodes`)
};

const fr_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les timecodes`)
};

const de_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes kopieren`)
};

const it_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia i codici temporali`)
};

const ru_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать временные метки`)
};

const es_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar códigos de tiempo`)
};

const zh_cn2_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制时间码`)
};

const ja_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードをコピー`)
};

const hi_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड कॉपी करें`)
};

const pt_pt2_copy_timecodes = /** @type {(inputs: Copy_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar códigos de tempo`)
};

/**
* | output |
* | --- |
* | "Copy timecodes" |
*
* @param {Copy_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_timecodes = /** @type {((inputs?: Copy_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_timecodes(inputs)
	if (locale === "de") return de_copy_timecodes(inputs)
	if (locale === "it") return it_copy_timecodes(inputs)
	if (locale === "ru") return ru_copy_timecodes(inputs)
	if (locale === "es") return es_copy_timecodes(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_timecodes(inputs)
	if (locale === "ja") return ja_copy_timecodes(inputs)
	if (locale === "hi") return hi_copy_timecodes(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_timecodes(inputs)
	return en_copy_timecodes(inputs)
});